export const iconStyle = {
    width: 30,
    height: 30,
    color: '#999',
  };